import { useQuery } from "@tanstack/react-query";
import { fetchMetaAdsAdDetail, isMetaAdsApiConfigured } from "./useMetaAdsApi";

/**
 * Loads a single Meta ad for the ad editor.
 */
export function useMetaAdsAdForEdit(adId, options = {}) {
  const { enabled = true } = options;
  const id = String(adId || "").trim();
  return useQuery({
    queryKey: ["meta-ads-ad-detail", id],
    queryFn: () => fetchMetaAdsAdDetail(id),
    enabled: Boolean(enabled && isMetaAdsApiConfigured() && id),
    staleTime: 30_000,
  });
}
